import { render, staticRenderFns } from "./WorkerEdit.vue?vue&type=template&id=4224bcf2&scoped=true&"
import script from "./WorkerEdit.vue?vue&type=script&lang=js&"
export * from "./WorkerEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkerEdit.vue?vue&type=style&index=0&id=4224bcf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4224bcf2",
  null
  
)

export default component.exports